export const getKeyValuePairs = <Key extends PropertyKey, V>(
  record: Record<Key, V>,
): { key: Key; value: V }[] => {
  const result: { key: Key; value: V }[] = []
  for (const key in record) {
    result.push({ key, value: record[key] })
  }
  return result
}

type MapRecordOverload = {
  <Key extends PropertyKey, V1, V2>(
    record: Record<Key, V1>,
    map: (value: V1, key: Key) => V2,
  ): Record<Key, V2>
  <Key extends PropertyKey, V1, V2>(
    record: Partial<Record<Key, V1>>,
    map: (value: V1 | undefined, key: Key) => V2,
  ): Record<Key, V2>
}

export const mapRecord: MapRecordOverload = <Key extends PropertyKey, V1, V2>(
  record: Record<Key, V1>,
  map: (value: V1, key: Key) => V2,
): Record<Key, V2> => {
  const result = Object.create(null) as Record<Key, V2>
  for (const key in record) {
    result[key] = map(record[key], key)
  }
  return result
}
